import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const ThreeModel = ({ modelPath }) => {
  const canvasRef = useRef();
  const [model, setModel] = useState(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const scene = new THREE.Scene();
    scene.background = null; // PRZEZROCZYSTE TŁO

    // Kamera
    const camera = new THREE.PerspectiveCamera(75, 1, 0.1, 1000);
    camera.position.set(0, 1, 2);
    camera.lookAt(0, 1, 0);

    // Renderer
    const renderer = new THREE.WebGLRenderer({
      canvas,
      antialias: true,
      alpha: true,
    });
    renderer.setPixelRatio(window.devicePixelRatio);

    // Światła
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.3);
    scene.add(ambientLight);

    const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
    directionalLight.position.set(5, 5, 5);
    scene.add(directionalLight);

    // Environment map dla odbić
    const envMap = new THREE.CubeTextureLoader().load([
      "./envmaps/1/nx.png",
      "./envmaps/1/ny.png",
      "./envmaps/1/nz.png",
      "./envmaps/1/px.png",
      "./envmaps/1/py.png",
      "./envmaps/1/pz.png",
    ]);
    scene.environment = envMap;

    // Loader modelu
    const loader = new GLTFLoader();
    loader.load(
      modelPath,
      (gltf) => {
        const loadedModel = gltf.scene;
        loadedModel.traverse((child) => {
          if (child.isMesh) {
            child.material.envMap = envMap;
            child.material.metalness = 1;
            child.material.roughness = 0.1;
          }
        });

        const group = new THREE.Group();
        group.add(loadedModel);
        loadedModel.position.set(0, 0, 0);
        group.position.set(0, 1, 0);

        // Powiększenie całej grupy o 1.5x
        group.scale.set(2, 2.5, 1.5);

        scene.add(group);
        setModel(group);
      },
      undefined,
      (error) => console.error("Błąd ładowania modelu:", error)
    );

    // Animacja
    const animate = () => {
      requestAnimationFrame(animate);
      renderer.render(scene, camera);
    };
    animate();

    // Resize – dynamicznie pobieramy wymiary canvas
    const handleResize = () => {
      const rect = canvas.getBoundingClientRect();
      camera.aspect = rect.width / rect.height;
      camera.updateProjectionMatrix();
      renderer.setSize(rect.width, rect.height);
    };
    handleResize(); // pierwsze ustawienie
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
      renderer.dispose();
    };
  }, [modelPath]);

  // ScrollTrigger – obrót modelu
  useEffect(() => {
    if (!model) return;

    gsap.to(model.rotation, {
      y: Math.PI * 4,
      scrollTrigger: {
        trigger: ".about-me",
        start: "center center",
        end: "+=1000",
        scrub: true,
        pin: true,
      },
    });
  }, [model]);

  return <canvas ref={canvasRef} className="three-canvas" />;
};

export default ThreeModel;
